import { render, staticRenderFns } from "./multipleTextStyle.vue?vue&type=template&id=54aa5720&"
import script from "./multipleTextStyle.vue?vue&type=script&lang=ts&"
export * from "./multipleTextStyle.vue?vue&type=script&lang=ts&"
import style0 from "./multipleTextStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports